/* GASSISA
=========================================================================================
* Descripcion: Version portatil del entrenamiento IA PC.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmEntrenamientoIAPC from "../../../ia/EntrenamientoPC/FrmEntrenamientoIAPC.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmEntrenamientoIAPCPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmEntrenamientoIAPC">
      <FrmEntrenamientoIAPC />
    </SizeSoftXFrmPortatil>
  );
}
